import React, { Component, } from 'react'
import { withStyles } from '@material-ui/core/styles';
import ZIconButton from '../components/ZIconButton';
import Avatar from '../components/ZAvatar'

class UserMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            avatar: '',
            alphabet: '',
            isAvatar: true
        }
    }
    componentDidMount() {
        var session = localStorage.getItem('user');
        var profile = JSON.parse(session)
        if (profile != null) {

            if (profile.profileAvatar.length > 2) {
                this.setState({
                    avatar: profile.profileAvatar,
                    isAvatar: true
                })
            } else {
                this.setState({
                    alphabet: profile.profileAvatar,
                    isAvatar: false
                })
            }

        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.profileImage != this.props.profileImage) {
            if (this.props.profileImage == "") {
                var session = localStorage.getItem('user');
                var profile = JSON.parse(session)
                if (profile != null) {

                    if (profile.profileAvatar.length > 2) {
                        this.setState({
                            avatar: profile.profileAvatar,
                            isAvatar: true
                        })
                    } else {
                        this.setState({
                            alphabet: profile.profileAvatar,
                            isAvatar: false
                        })
                    }

                }
            }
            if (this.props.profileImage != undefined && this.props.profileImage != "" && this.props.profileImage != null) {
                if (this.props.profileImage.length > 2) {
                    this.setState({
                        avatar: this.props.profileImage,
                        isAvatar: true
                    })
                } else {
                    this.setState({
                        alphabet: this.props.profileImage,
                        isAvatar: false
                    })
                }
            }
        }
    }

    render() {


        const { classes } = this.props
        return (
            <div className={classes.container}>
                <ZIconButton onClick={(e) => this.props.onClick(e)}>
                    {this.state.isAvatar ?
                        <Avatar src={this.state.avatar} style={{ border: "2px solid #0B5C7E" }} />
                        :
                        <Avatar style={{ border: "2px solid #0B5C7E", backgroundColor: "#0B5C7E" }}>{this.state.alphabet.toUpperCase()}</Avatar >
                    }
                </ZIconButton>
            </div>
        )
    }
}

const styles = theme => ({
    container: {
        display: "flex",
        marginLeft: 5,
    },
});
// const mapStateToProps = state => {
//     return {
//         profileImage: state.header.profileImage,
//     };
// };

// const dispatchToProps = (dispatch) => {
//     return {

//     };
// };

export default withStyles(styles)(UserMenu);
